// Utils
import { Affiliation } from '@gql';

// UI
import { Icon, IconNames } from '@components/icon';
import { Typography } from '@components/typography';

type Props = {
  affiliations: Pick<Affiliation, 'name' | 'type'>[];
};

export const AwardsSection: React.FC<Props> = ({ affiliations }) => {
  return (
    <div
      className="flex flex-col space-y-3"
      data-testid="@awards/awards-details"
    >
      {affiliations.map((affiliation, index) => (
        <div key={index} className="flex flex-row items-center">
          <Icon name={IconNames.AWARD} className="text-gray-light" />
          <Typography
            component="span"
            variant="body2"
            variantM="body1"
            className="ml-4"
          >
            {affiliation.name}
          </Typography>
        </div>
      ))}
    </div>
  );
};
